    
    <p-checkbox
      [disabled]="node && node.parent"
      pInputCheckbox
      binary="true"
      (onChange)="onChange($event)"
      [ngModel]="isSelected()"
    ></p-checkbox>
  